module.exports = __webpack_public_path__ + "static/media/nancy.f063c358.jpg";